module.exports = __webpack_public_path__ + "static/turkbox2-10f7ef83e52481b45dc7b7043c003c33.jpg";